/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntityHoneypotsResult
 */
export interface ControlEntityHoneypotsResult {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityHoneypotsResult
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityHoneypotsResult
     */
    entity_domain?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityHoneypotsResult
     */
    entity_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityHoneypotsResult
     */
    asset?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityHoneypotsResult
     */
    source_asset?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityHoneypotsResult
     */
    port?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityHoneypotsResult
     */
    tags?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlEntityHoneypotsResult
     */
    shared?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityHoneypotsResult
     */
    found?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityHoneypotsResult
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityHoneypotsResult
     */
    updated?: string;
}

/**
 * Check if a given object implements the ControlEntityHoneypotsResult interface.
 */
export function instanceOfControlEntityHoneypotsResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityHoneypotsResultFromJSON(json: any): ControlEntityHoneypotsResult {
    return ControlEntityHoneypotsResultFromJSONTyped(json, false);
}

export function ControlEntityHoneypotsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityHoneypotsResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'entity_domain': !exists(json, 'entity_domain') ? undefined : json['entity_domain'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'source_asset': !exists(json, 'source_asset') ? undefined : json['source_asset'],
        'port': !exists(json, 'port') ? undefined : json['port'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'found': !exists(json, 'found') ? undefined : json['found'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
    };
}

export function ControlEntityHoneypotsResultToJSON(value?: ControlEntityHoneypotsResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'entity_domain': value.entity_domain,
        'entity_name': value.entity_name,
        'asset': value.asset,
        'source_asset': value.source_asset,
        'port': value.port,
        'tags': value.tags,
        'shared': value.shared,
        'found': value.found,
        'created': value.created,
        'updated': value.updated,
    };
}

